import { SButton } from '@setvi/shared/components';
import { ResourceType } from '@setvi/shared/enums';
import { resourceView } from '@setvi/shared/utils/viewer';
import { useQuery } from '@tanstack/react-query';
import { DetailsDialogProps } from 'componentsV2/product/details';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { productAssociatedResources } from 'Services';

type ThreeSixtyViewProps = {
  productSku: string;
} & Pick<DetailsDialogProps, 'captureResourceAnalytics'>;

const ThreeSixtyViewButton = ({
  productSku,
  captureResourceAnalytics
}: ThreeSixtyViewProps) => {
  const { data, isLoading } = useQuery(productAssociatedResources(productSku));
  const threeSixtyViewResource = data?.Resources.find(
    (resource: any) => resource.ResourceTypeID === ResourceType.WebPage
  );

  const handleOpenThreeSixtyView = () => {
    captureResourceAnalytics?.({
      categoryName: threeSixtyViewResource.CategoryName
    });
    resourceView({
      name: threeSixtyViewResource.Name,
      resourceTypeId: threeSixtyViewResource.ResourceTypeID,
      resourceId: threeSixtyViewResource.ResourceID
    });
  };

  if (isLoading || !threeSixtyViewResource) return null;

  return (
    <SButton
      variant="outlined"
      onClick={handleOpenThreeSixtyView}
      style={{
        borderRadius: 36
      }}>
      View 3D
    </SButton>
  );
};

export const ThreeSixtyView = ({
  productSku,
  captureResourceAnalytics
}: ThreeSixtyViewProps) => {
  const flags = useFlags();

  if (flags.productsThreeSixtyView)
    return (
      <ThreeSixtyViewButton
        productSku={productSku}
        captureResourceAnalytics={captureResourceAnalytics}
      />
    );

  return null;
};
